import { cn } from '@/shared/lib/utils';

interface SegmentedControlProps<T extends string> {
  /** 스크린리더용 묶음 이름 (예: '다운로드 대상') */
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  /** md 48px(Body 15) · sm 44px(Body 14) */
  size?: 'md' | 'sm';
}

/**
 * Figma Segmented — 같은 폭 버튼 중 하나를 고른다.
 * 선택: 2px primary-500 테두리 + primary-50 배경 + accent 굵은 글자, 기본: 1.5px line-grey 테두리.
 */
export function SegmentedControl<T extends string>({
  label,
  value,
  options,
  onChange,
  size = 'md',
}: SegmentedControlProps<T>) {
  return (
    <div role="radiogroup" aria-label={label} className="flex w-full gap-2">
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.value)}
            className={cn(
              'flex min-w-0 flex-1 cursor-pointer items-center justify-center rounded-12 px-2 whitespace-nowrap outline-none focus-visible:ring-2 focus-visible:ring-fg-accent/40',
              size === 'md' ? 'h-12 text-body-15' : 'h-11 text-body-14',
              selected
                ? 'border-2 border-primary-500 bg-primary-50 font-bold text-fg-accent'
                : 'border-[1.5px] border-line-grey bg-surface-white font-medium text-fg-primary hover:bg-surface-grey',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
